import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import React from 'react';
import HrCaption from './HrCaption';
import PasswordResetForm from './PasswordResetForm';

const PasswordResetDialog = props => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { open, handleClose } = props;
  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle className="text-center" id="form-dialog-title">
          Reset your Password
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              padding: '2px',
            }}
          >
            <IconButton onClick={handleClose} aria-label="Close" size="large">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <FormLabel component="legend">
            Forgot your password? We will send you an email to reset your
            password.
          </FormLabel>
          <PasswordResetForm />
          <HrCaption text="Remembered it?" />
          <div className="pb-3">
            <Typography
              color="primary"
              align="center"
              onClick={props.switch}
              onKeyPress={props.switch}
              role="link"
              tabIndex={0}
              className="cpointer"
            >
              Back to login
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

PasswordResetDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default PasswordResetDialog;
